import { toast } from "react-toastify";

const validateFile = (file,name,setFileUploadFlag,setError) => {
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes

    if (file && file.file?.size > maxSize) {
      setFileUploadFlag(false);
      toast.error('File size should be less than 2MB.');
      setError("dealer_pan_card_image", {
        type: "validate",
        message: "File size should be less than 2MB.",
      });
      return
    } else {
      setFileUploadFlag(true);
    }
  };

  export default validateFile